import { render, staticRenderFns } from "./digit.vue?vue&type=template&id=672cfa03&scoped=true"
import script from "./digit.vue?vue&type=script&lang=js"
export * from "./digit.vue?vue&type=script&lang=js"
import style0 from "./digit.vue?vue&type=style&index=0&id=672cfa03&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672cfa03",
  null
  
)

export default component.exports